import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { MessageModalComponent } from './message-modal/message-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(private modalService: BsModalService) {}

  open( message: string): BsModalRef {
    return this.modalService.show(MessageModalComponent, {
      initialState: {
        message
      }
    });
  }
}
